var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCardCreditCard = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M70 0v70H0V0h70z",
    id: "kzd9qrwzda"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#kzd9qrwzda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.34 5.798-2.722-1.71a1.667 1.667 0 0 0-1.65.345L13.251 29.33a4.916 4.916 0 0 0-.773 1.174 5.284 5.284 0 0 0-.47 2.519v30.486a.676.676 0 0 0 .444.637l2.446 1.45.57-33.704L58.34 5.798z",
    fill: "#CC8C79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.661 64.57V34.663c-.018-.429-.015-1.684.804-2.772.3-.401.632-.673.905-.853L56.858 6.14l.852-.472c.104-.01.484-.035.826.236.536.426.462 1.174.46 1.21v30.924a4.466 4.466 0 0 1-.728 1.677 4.189 4.189 0 0 1-1.254 1.164L16.286 65.777c-.067.051-.406.297-.816.2-.444-.103-.788-.567-.817-1.14",
    fill: "#E1BDB0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C1913",
    d: "M14.69 37.338v4.784l44.292-27.016v-4.959"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9F4F5",
    d: "M19.209 42.583v9.808l36.437-22.23v-9.902"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C3629",
    d: "M39.839 43.33v.618l16.108-9.975v-.687M39.892 45.574v.619l16.106-9.976v-.687M39.933 47.71v.618l16.106-9.975v-.687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.834 61.861v-5.737a1.428 1.428 0 0 1 .78-.826l4.101-2.501c.245-.025.452.068.513.226a.317.317 0 0 1 .018.162v5.46a.776.776 0 0 1-.133.424.748.748 0 0 1-.439.31l-4.486 2.726c-.163.06-.298.058-.34-.008a.096.096 0 0 1-.012-.053l-.005-.185.003.002z",
    fill: "#90563E"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCardCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-card-credit-card.b7720ab1962aed6e59b6c7a5d58a30fe.svg";